import config from '../config/config';
const pathname = window.location.pathname;
const userAgentRegExp = /Android|webOS|iPhone|iPod|BlackBerry/i;
if(!userAgentRegExp.test(navigator.userAgent)) {
    const currentId = pathname.substr(pathname.lastIndexOf('/')+1);
    if(pathname.indexOf('listPage') > -1) {
        window.location.href = `${config.ROOTAPI}page/${currentId}?pageSize=8`;
    } else if(pathname.indexOf('news') > -1) {
        window.location.href = `${config.ROOTAPI}news/${currentId}.html`;
    } else {
        window.location.href = config.ROOTAPI;
    }
}


// WEBPACK FOOTER //
// ./src/utils/init.tsx